import { render, staticRenderFns } from "./MStoreFormGroup.vue?vue&type=template&id=2074d0d2&"
import script from "./MStoreFormGroup.vue?vue&type=script&lang=ts&"
export * from "./MStoreFormGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports